module.exports = __webpack_public_path__ + "static/img/ginger_pictgrid12_450x451.5f73bca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ginger_pictgrid12_450x451.jpg
// module id = srcY
// module chunks = 0